import type { LogEvent } from 'relay-runtime';

export const relayTransactionLogger = (event: LogEvent) => {
  if (process.env.RELAY_LOGGER === 'true') {
    // eslint-disable-next-line
    console.log('RELAY: ', event);
  }

  return;
};
